import { translations } from '../../translations';

export const ruTranslation = {
    ...translations.ru,
};
